import React from 'react';
import PositiveBlastChillingRulesEditor from './PositiveBlastChillingRulesEditor';

export default function NegativeBlastChillingRulesEditor(props) {
  return <PositiveBlastChillingRulesEditor {...props} kind="negative" />;
}
